import dayjs from "dayjs";
import { api } from "@service/api";
import { useEffect, useState } from "react";

import { Card } from "@components/cards/card";
import { Input } from "@components/forms/input";
import { Pagination } from "@components/pagination";
import { Button } from "@components/buttons/button";
import { Masks } from "@hooks/functions/Masks/Masks";
import { ICustomerPublicListDTO } from "@hooks/dtos/user-dto";
import { LoadingSkeleton } from "@components/skeleton-loading";
import { FaBroom, FaExpand, FaEye, FaMinus } from "react-icons/fa6";
import { getCustomerStatus } from "@hooks/functions/Customer/status";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { CustomerStatusTypes } from "@hooks/dtos/customer/ICustomerDTO";
import { abbreviateName, formatName } from "@hooks/functions/formatName";
import { Link } from "react-router-dom";

interface ICustomerListParams {
  page: number;
  startAt: string;
  endAt: string;
}

const masks = new Masks();
export function CustomerList() {
  // --- Default Variables --- //
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  // --- Another Control --- //
  const [show, setShow] = useState<{ filter: boolean }>({
    filter: false,
  });

  // Pagination Part
  const [page, setPage] = useState<number>(1);
  const [take, setTake] = useState<number>(10);
  const [order, setOrder] = useState("DESC");
  const [totalPages, setTotalPages] = useState<number>(1);

  // Filters
  const [resultTime, setResultTime] = useState("Todo Período");
  const [searchCustomer, setSearchCustomer] = useState<string | undefined>();
  const [status, setStatus] = useState<CustomerStatusTypes>();
  const [startAt, setStartDate] = useState("");
  const [endAt, setEndDate] = useState("");

  const [isLoading, setIsLoading] = useState({
    card: false,
    history: true,
  });

  const [customers, setCustomers] = useState<ICustomerPublicListDTO[]>();

  // Affiliate Table List
  async function getCustomerList({
    page,
    startAt,
    endAt,
  }: ICustomerListParams) {
    try {
      const params = `?${new URLSearchParams(
        Object.entries({
          page: (page || 1).toString(),
          take: take.toString(),
          order,
          ...(searchCustomer && { search: searchCustomer }),
          ...(status && { status }),
          ...(startAt && { startAt }),
          ...(endAt && { endAt }),
        }),
      ).toString()}`;
      const result = await api.get(`/misc/customer/search${params}`);
      // console.log({ params, data: result.data, ret: result.data.customer });

      setCustomers(result.data.customers);
      setTotalPages(result.data.totalPages);
      setIsLoading((prev) => ({ ...prev, history: false }));
    } catch (err: any) {
      setIsLoading((prev) => ({ ...prev, history: false }));
      pushToastify({
        message: err?.response?.data.message ?? "Ocorreu um erro!",
        type: "error",
        theme: "dark",
      });
    }
  }

  async function cleanFilters() {
    // --- Main Filters --- //
    setStatus(undefined);
    setSearchCustomer(undefined);

    // --- Anothers --- //
    setStartDate("");
    setEndDate("");
    handleSubmit("", "");
  }

  function handleSubmit(_startDate: string, _endDate: string) {
    setIsLoading({ card: true, history: true });
    setResultTime(
      _startDate.length + _endDate.length > 0
        ? `Período Selecionado`
        : `Todo Período`,
    );
    getCustomerList({
      page,
      startAt: _startDate,
      endAt: _endDate,
    });
  }

  useEffect(() => {
    getCustomerList({
      page,
      startAt,
      endAt,
    });
  }, [page]);

  useEffect(() => {
    getCustomerList({
      page,
      startAt,
      endAt,
    });
  }, []);

  return (
    <>
      {/* Filters */}
      <div className="row">
        <div className="col-md-12">
          <Card>
            <div
              className="card-header"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setShow((prev) => ({
                  ...prev,
                  filter: !show.filter,
                }));
              }}
            >
              <div className="d-flex justify-content-between">
                <div className="">
                  <div className="card-title">Filtrar Registros</div>
                  <div className="card-category">
                    Utilize o filtro para trazer um período específico.
                  </div>
                </div>
                <div className="">
                  {show.filter ? (
                    <FaMinus
                      className="fs-5"
                      title="Clique para ocultar as informações."
                    />
                  ) : (
                    <FaExpand
                      className="fs-5"
                      title="Clique para visualizar as informações."
                    />
                  )}
                </div>
              </div>
            </div>
            <div className={`card-body ${show.filter ? `` : `d-none`}`}>
              {/* Another Filters */}
              <div className="row mt-2">
                <div className="col-md-4">
                  <Input
                    animated
                    label="Nome ou @arroba do Usuário"
                    placeholder=""
                    type="text"
                    value={searchCustomer || ""}
                    onChange={(e) => {
                      setSearchCustomer(e.target.value);
                    }}
                    onKeyUp={(e) =>
                      e.key === "Enter" && handleSubmit(startAt, endAt)
                    }
                  />
                </div>
                {/* Dates */}
                <div className="col-md-4">
                  <Input
                    animated
                    id="startAt"
                    label="Data Inicial"
                    placeholder=""
                    type="date"
                    value={startAt}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>
                <div className="col-md-4">
                  <Input
                    animated
                    id="endAt"
                    label="Data Final"
                    placeholder=""
                    type="date"
                    value={endAt}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
              </div>

              {/* Buttons */}
              <div className="row d-flex justify-content-end mt-2">
                <div className="col-md-2">
                  <div className="d-flex justify-content-between">
                    <div className="form-group">
                      <button
                        className="btn btn-sm btn-success form-control rounded px-5"
                        onClick={() => handleSubmit(startAt, endAt)}
                      >
                        Filtrar
                      </button>
                      <small className="text-muted ms-1"> </small>
                    </div>
                    <div className="form-group">
                      <button
                        className="btn btn-sm btn-warning form-control rounded text-white"
                        onClick={cleanFilters}
                        title="Limpar todos os filtros."
                      >
                        <FaBroom />
                      </button>
                      <small className="text-muted ms-1"> </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>

      {/* Table */}
      <div className="row">
        <div className="col-md-12">
          <Card>
            <div className="card-header">
              <div className="row">
                {/* Header of the Table */}
                <div className="col-md-8">
                  <h4 className="card-title">Relação de Usuários</h4>
                  <p className="card-category">Usuários da Plataforma</p>
                </div>
                {/* Ordenate Table */}
                <div className="col-md-4">
                  <div className="row align-items-center">
                    <div className="col-md-4">
                      <div className="form-group">
                        <select
                          className="form-select"
                          aria-label="Quantidade de Registros por Página"
                          value={take}
                          onChange={(e) => setTake(Number(e.target.value))}
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="75">75</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <select
                          className="form-select"
                          aria-label="Ordenação da Tabela"
                          value={order}
                          onChange={(e) => setOrder(e.target.value)}
                        >
                          <option value="ASC">Crescente</option>
                          <option value="DESC">Decrescente</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <button
                          className="btn btn-sm btn-success form-control px-2"
                          onClick={() => handleSubmit(startAt, endAt)}
                        >
                          Aplicar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <div
                  id="basic-datatables_wrapper"
                  className="dataTables_wrapper container-fluid dt-bootstrap4"
                >
                  <div
                    id="basic-datatables_length"
                    className="dataTables_length"
                  >
                    <table className="table table-striped">
                      <thead>
                        <tr role="row">
                          <th style={{ minWidth: "2rem" }}>Identificação</th>
                          <th>Localidade</th>
                          <th>Status</th>
                          <th>Cadastro</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading.history && (
                          <tr>
                            <td colSpan={10} className="text-center">
                              <LoadingSkeleton />
                            </td>
                          </tr>
                        )}

                        {customers &&
                          customers.length > 0 &&
                          customers.map((customer) => {
                            const status = getCustomerStatus(customer.status);
                            const customerName = formatName(
                              customer?.name
                                ? abbreviateName(customer?.name, 15)
                                : "~",
                            );
                            return (
                              <tr key={customer?.id}>
                                <td className="">
                                  <div className="d-flex flex-column">
                                    <span title={formatName(customer?.name)}>
                                      {customerName}
                                    </span>
                                    <small className="text-muted">
                                      @{customer?.atSign || "~"}
                                    </small>
                                  </div>
                                </td>
                                <td>
                                  {customer.cityName}, {customer.stateName} -{" "}
                                  {customer.countryName}
                                </td>
                                <td>
                                  <span
                                    className={`badge bg-${status.color}`}
                                    title={status.text}
                                  >
                                    {status.title}
                                  </span>
                                </td>
                                <td>
                                  {dayjs(customer?.createdAt).format(
                                    "DD/MM/YYYY [ás] HH:MM:ss",
                                  )}
                                </td>
                                <td>
                                  <Link
                                    className="btn btn-info rounded text-white py-1 px-3"
                                    to={`/profile?atsign=${customer.atSign}`}
                                  >
                                    Perfil
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}

                        {isLoading.history ||
                          !customers ||
                          (customers?.length <= 0 && (
                            <tr>
                              <td colSpan={12} className="text-center">
                                Nenhum registro encontrado.
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <Pagination
                page={page}
                setPage={setPage}
                totalPages={totalPages}
                maxPageShow={3}
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
